import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';

function Beta() {

  return (
    <Row className="justify-content-center">
      <Col md={12} lg={6}>
        <p>Apply to ChameleonTiny Manager beta</p>
        <Form data-netlify="true" name="beta" method="POST" action="/thankyou">
          <input type="hidden" name="form-name" value="beta" />
          <Form.Group controlId="name">
            <Form.Label>Name</Form.Label>
            <Form.Control type="text" name="name" placeholder="Enter name" />
          </Form.Group>

          <Form.Group as={Row} controlId="formHorizontalBotField" hidden>
            <Form.Label column sm={2}>
              Don’t fill this out if you’re human:
            </Form.Label>
            <Col sm={6}>
              <Form.Control name="bot-field" />
            </Col>
          </Form.Group>

          <Form.Group controlId="email">
            <Form.Label>Email address</Form.Label>
            <Form.Control type="email" name="email" placeholder="Enter email" />
            <Form.Text className="text-muted">
              We'll never share your email with anyone else.  Used to send invite.
            </Form.Text>
          </Form.Group>

          <Form.Group controlId="device">
            <Form.Label>Chameleon Device</Form.Label>
            <Form.Control type="text" name="device" placeholder="" />
          </Form.Group>

          <Form.Group controlId="os">
            <Form.Check type="checkbox" name="os" label="iPhone running iOS 15?" />
          </Form.Group>

          <Form.Group controlId="hear">
            <Form.Label>How did you hear of CTManager?</Form.Label>
            <Form.Control as="textarea" name="hear" rows={2} />
          </Form.Group>

          <Button variant="primary" type="submit">
            Submit
          </Button>
        </Form>
      </Col>
    </Row>
  );
}

export default Beta;
